module.exports = __webpack_public_path__ + "static/media/longIslandEast.bd294ba2.png";